var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuseum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-42,-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "museum",
    transform: "matrix(1,0,0,1,9.89832,21.3033)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.663736,0,0,0.485083,9.61215,2.42963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.333,63.262L35.137,63.262L35.137,58.021L61.446,49.594L87.353,57.595L87.333,63.262Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.663736,0,0,0.485083,9.61215,2.42963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.333,64.293C87.748,64.293 88.085,63.835 88.087,63.267L88.106,57.6C88.108,57.116 87.863,56.696 87.519,56.589L61.612,48.588C61.5,48.554 61.385,48.555 61.274,48.59L34.965,57.017C34.625,57.127 34.384,57.542 34.384,58.021L34.384,63.262C34.384,63.832 34.721,64.293 35.137,64.293L87.333,64.293Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989175,0,0,1,0.538122,6.0945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.424,42.687C32.201,42.687 32.02,42.866 32.02,43.087L32.02,44.812C32.02,45.033 32.202,45.212 32.425,45.212L67.676,45.212C67.899,45.212 68.08,45.033 68.08,44.812L68.08,43.007C68.08,42.787 67.899,42.607 67.676,42.607L66.012,42.607C66.012,42.607 66.012,41.633 66.012,41.633C66.012,41.412 65.831,41.233 65.608,41.233L34.37,41.232C34.263,41.232 34.16,41.274 34.084,41.349C34.009,41.424 33.966,41.526 33.966,41.632L33.966,42.683C33.966,42.683 32.424,42.687 32.424,42.687Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.919472,0,0,1.07221,-5.67593,-3.50993)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.738,
    y: 37.006,
    width: 4.132,
    height: 10.693,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.919472,0,0,1.07221,6.09245,-3.50993)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.738,
    y: 37.006,
    width: 4.132,
    height: 10.693,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.919472,0,0,1.07221,17.7925,-3.50993)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.738,
    y: 37.006,
    width: 4.132,
    height: 10.693,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.65241,0,0,0.114784,-25.2266,32.1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.279,35.96C40.279,34.156 40.177,32.693 40.052,32.693L36.811,32.693C36.686,32.693 36.584,34.156 36.584,35.96L36.584,49.386C36.584,51.191 36.686,52.653 36.811,52.653L40.052,52.653C40.177,52.653 40.279,51.191 40.279,49.386L40.279,35.96Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.65241,0,0,0.114784,-13.5087,32.1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.279,35.96C40.279,34.156 40.177,32.693 40.052,32.693L36.811,32.693C36.686,32.693 36.584,34.156 36.584,35.96L36.584,49.386C36.584,51.191 36.686,52.653 36.811,52.653L40.052,52.653C40.177,52.653 40.279,51.191 40.279,49.386L40.279,35.96Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.65241,0,0,0.114784,-1.85584,32.1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.279,35.96C40.279,34.156 40.177,32.693 40.052,32.693L36.811,32.693C36.686,32.693 36.584,34.156 36.584,35.96L36.584,49.386C36.584,51.191 36.686,52.653 36.811,52.653L40.052,52.653C40.177,52.653 40.279,51.191 40.279,49.386L40.279,35.96Z",
    style: {
      fill: "white"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseum);
export default __webpack_public_path__ + "static/media/museum.4f341635a64cd6f382b662cacda231d9.svg";
export { ForwardRef as ReactComponent };